var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useRef } from "react";
var initialRect = {
    width: -1,
    tabRight: -1,
};
var hasChanged = function (prevValues, values) {
    if (prevValues.width === initialRect.width)
        return true;
    if (prevValues.width === values.width && prevValues.tabRight !== values.tabRight)
        return true;
    return prevValues.width !== values.width;
};
export default (function (parentRef, ref, target, callback, deps) {
    var prevValuesRef = useRef(initialRect);
    return useCallback(function () {
        if (!ref.current || !target.current.length)
            return;
        var width = document.body.clientWidth;
        var draggableTabs = ref.current;
        var draggableLeft = draggableTabs.getBoundingClientRect().left;
        var container = parentRef.current;
        var _a = container.getBoundingClientRect(), containerRight = _a.right, containerLeft = _a.left;
        if (!prevValuesRef.current.expandedStaticWidth) {
            prevValuesRef.current.expandedStaticWidth = draggableLeft - containerLeft;
        }
        var lastTab = target.current[target.current.length - 1];
        var _b = lastTab.getBoundingClientRect(), tabRight = _b.right, tabWidth = _b.width;
        if (!hasChanged(prevValuesRef.current, { width: width, tabRight: tabRight }))
            return;
        var padRight = width - containerRight;
        if (tabRight < width - padRight &&
            containerLeft +
                prevValuesRef.current.expandedStaticWidth +
                (tabRight - draggableLeft) +
                padRight >
                width)
            return;
        prevValuesRef.current = __assign(__assign({}, prevValuesRef.current), { width: width, tabRight: tabRight, containerRight: containerRight });
        if (tabRight >= containerRight && !prevValuesRef.current.collapse) {
            prevValuesRef.current.collapse = true;
            return callback(true);
        }
        if (tabRight + tabWidth < containerRight &&
            (prevValuesRef.current.collapse || typeof prevValuesRef.current.collapse === "undefined")) {
            prevValuesRef.current.collapse = false;
            return callback(false);
        }
    }, deps);
});
